module.exports = __webpack_public_path__ + "img/软件服务智慧政务2.edbdea7d.png";